<template>
  <div class="player-container">
    <video ref="videoPlayer" class="video-js"></video>
  </div>
</template>

<script>
import videojs from 'video.js';

export default {
  name: "videoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      player: null,
      loading: false
    }
  },
  mounted() {
    this.player = videojs(this.$refs.videoPlayer, this.options, () => {
      this.loading = true;
    });

    const playerEl = this.$refs.videoPlayer;
    if (playerEl) {
      if (playerEl.addEventListener) {
        playerEl.addEventListener('contextmenu', function (e) {
          e.preventDefault();
        }, false);
      } else if (playerEl.attachEvent) {
        playerEl.attachEvent('oncontextmenu', function () {
          window.event.returnValue = false;
        });
      }
    }

  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
</script>

<style scoped>

</style>
